import { InvoiceStatus } from "../../InvoiceFilters/types";
import {
  type DraftMode,
  DraftStatus,
  type FinalisedMode,
  FinalisedStatus,
  InvoiceMode,
} from "../InvoiceActions";

export const getDisplayOptions = (invoice) => {
  const isNotFinalised = invoice?.invoiceStatus === InvoiceStatus.Draft;
  const isEmpty = invoice?.lineItems?.length < 1;
  const isPaid = invoice?.invoiceStatus === InvoiceStatus.Paid;
  const isPartiallyPaid =
    invoice?.invoiceStatus === InvoiceStatus.PartiallyPaid &&
    invoice?.hasPatientPayer;
  const isUnpaid =
    invoice?.invoiceStatus === InvoiceStatus.Unpaid ||
    (invoice?.invoiceStatus === InvoiceStatus.PartiallyPaid &&
      !invoice?.hasPatientPayer);
  const isRefunded = invoice?.invoiceStatus === InvoiceStatus.Refunded;

  const isVoid = invoice?.invoiceStatus === InvoiceStatus.Void;
  const isPartiallyRefunded =
    invoice?.invoiceStatus === InvoiceStatus.PartiallyRefunded;
  const isPending = invoice?.invoiceStatus === InvoiceStatus.Pending;

  let mode;

  if (isNotFinalised) {
    const draftMode = { mode: InvoiceMode.DRAFT, status: "" };
    if (isEmpty) {
      draftMode.status = DraftStatus.EMPTY;
    } else {
      draftMode.status = DraftStatus.POPULATED;
    }
    mode = draftMode as DraftMode;
  } else {
    const finalisedMode = { mode: InvoiceMode.FINALISED, status: "" };
    if (isPaid) {
      finalisedMode.status = FinalisedStatus.PAID;
    } else if (isRefunded) {
      finalisedMode.status = FinalisedStatus.REFUNDED;
    } else if (isVoid) {
      finalisedMode.status = FinalisedStatus.VOID;
    } else if (isPartiallyRefunded) {
      finalisedMode.status = FinalisedStatus.PARTIALLY_REFUNDED;
    } else if (isPending) {
      finalisedMode.status = FinalisedStatus.PENDING;
    } else if (isPartiallyPaid) {
      finalisedMode.status = FinalisedStatus.PARTIALLY_PAID;
    } else if (isUnpaid) {
      finalisedMode.status = FinalisedStatus.UNPAID;
    }
    mode = finalisedMode as FinalisedMode;
  }

  return mode;
};
